import React, { Component } from 'react';
import {
  Container,
  Image,
  Icon,
  Header,
  Grid,
  Responsive
} from 'semantic-ui-react';
import application from '../images/application.png';

class AboutSection extends Component {
  state = {
    activeItem: 'home'
  };
  render() {
    return (
      <Container fluid textAlign="center" id="about">
        <Header as="h2" style={{ padding: '3em 0' }}>
          {' '}
          Paraphe Online est destiné aux entreprises nécessitant de faire signer
          et/ou modifier à distance des documents par leurs collaborateurs.
          <Header.Subheader>
            Le service est paramétrable afin de s'adapter à votre flux de
            travail
          </Header.Subheader>
        </Header>
        <Header as="h3">
          Example d'utilisation :
          <Header.Subheader>
            Mr Pierre a besoin de la signature de son supérieur hiérarchique, Mr
            Paul, pour valider des documents avant de les envoyer à un client.
          </Header.Subheader>
        </Header>
        <Grid stackable style={{ paddingBottom: '2em' }}>
          <Grid.Row columns={6} centered>
            <Grid.Column verticalAlign="middle">
              <Header as="div" style={{ padding: '1em 0' }}>
                <div>
                  <Icon name="edit big" />
                </div>
                <Header.Content
                  style={{
                    marginTop: '1em',
                    border: '1px black solid',
                    backgroundColor: 'rgba(0,122,163,0.5)',
                    padding: '1em'
                  }}
                >
                  {' '}
                  Mr Pierre crée un document sur l'ERP de son entreprise{' '}
                </Header.Content>
              </Header>
            </Grid.Column>
            <Grid.Column verticalAlign="middle">
              <Header as="div" style={{ padding: '1em 0' }}>
                <div>
                  <Responsive minWidth={769}>
                    <Icon name="long arrow alternate right big" />
                  </Responsive>
                  <Responsive maxWidth={768}>
                    <Icon name="long arrow alternate down big" />
                  </Responsive>
                </div>
                <Header.Content
                  style={{
                    marginTop: '1em',
                    border: '1px black solid',
                    backgroundColor: 'rgba(0,150,155,0.5)',
                    padding: '1em'
                  }}
                >
                  {' '}
                  L'ERP envoie les informations sur le document à l'API Paraphe
                  Online{' '}
                </Header.Content>
              </Header>
            </Grid.Column>
            <Grid.Column verticalAlign="middle">
              <Header as="div" style={{ padding: '1em 0' }}>
                <div>
                  <Icon name="bell outline big" />
                </div>
                <Header.Content
                  style={{
                    marginTop: '1em',
                    border: '1px black solid',
                    backgroundColor: 'rgba(0,122,163,0.5)',
                    padding: '1em'
                  }}
                >
                  {' '}
                  Mr Paul reçoit une notification, il effectue des modifications
                  sur le document et le signe{' '}
                </Header.Content>
              </Header>
            </Grid.Column>
            <Grid.Column verticalAlign="middle">
              <Header as="div" style={{ padding: '1em 0' }}>
                <div>
                  <Responsive minWidth={769}>
                    <Icon name="long arrow alternate right big" />
                  </Responsive>
                  <Responsive maxWidth={768}>
                    <Icon name="long arrow alternate down big" />
                  </Responsive>
                </div>
                <Header.Content
                  style={{
                    marginTop: '1em',
                    border: '1px black solid',
                    backgroundColor: 'rgba(0,150,155,0.5)',
                    padding: '1em'
                  }}
                >
                  {' '}
                  Paraphe Online génère le document signé et l'envoie par email
                  au client, l'ERP recupère les modifications.{' '}
                </Header.Content>
              </Header>
            </Grid.Column>
            <Grid.Column verticalAlign="middle">
              <Header as="div" style={{ padding: '1em 0' }}>
                <div>
                  <Icon name="envelope outline big" />
                </div>
                <Header.Content
                  style={{
                    marginTop: '1em',
                    border: '1px black solid',
                    backgroundColor: 'rgba(0,122,163,0.5)',
                    padding: '1em'
                  }}
                >
                  Mr Pierre reçoit un email lui indiquant que son document a été
                  traité
                </Header.Content>
              </Header>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <div
          style={{
            backgroundColor: '#002033',
            color: 'rgba(255,255,255,0.5)',
            paddingBottom: '2em'
          }}
        >
          <Container>
            <Header
              as="h2"
              style={{ padding: '3em 0', color: 'rgba(255,255,255,0.8)' }}
            >
              {' '}
              Une application de signature éléctronique simple et rapide
              <Header.Subheader style={{ color: 'rgba(255,255,255,0.5)' }}>
                L'application mobile permet de modifier les informations d'un
                document puis de le signer.
              </Header.Subheader>
            </Header>
            <Grid stackable textAlign="center">
              <Grid.Row columns={2} stretched>
                <Grid.Column width={6}>
                  <Image
                    src={application}
                    size="medium"
                    style={{ margin: 'auto' }}
                  />
                </Grid.Column>
                <Grid.Column width={10}>
                  <Grid stackable columns={2}>
                    <Grid.Column>
                      <Header
                        icon
                        as="h3"
                        style={{
                          padding: '1em 0',
                          color: 'rgba(255,255,255,0.8)'
                        }}
                      >
                        <Icon name="mobile alternate big" />
                        Disponible partout
                      </Header>
                      <p>
                        {' '}
                        Signez et consultez vos documents où que vous soyez{' '}
                      </p>
                    </Grid.Column>
                    <Grid.Column>
                      <Header
                        icon
                        as="h3"
                        style={{
                          padding: '1em 0',
                          color: 'rgba(255,255,255,0.8)'
                        }}
                      >
                        <Icon name="options" />
                        Flexible
                      </Header>
                      <p>
                        {' '}
                        Configurez le fonctionnement de l'application avec notre
                        interface d'administration web.
                      </p>
                      <p>
                        {' '}
                        Gérez vos groupes, utilisateurs et leurs certificats,
                        personnalisez les emails envoyés...
                      </p>
                    </Grid.Column>
                    <Grid.Column>
                      <Header
                        icon
                        as="h3"
                        style={{
                          padding: '1em 0',
                          color: 'rgba(255,255,255,0.8)'
                        }}
                      >
                        <Icon name="copy" /> Créez vos modèles
                      </Header>
                      <p>
                        {' '}
                        Créez vos modèles de documents, choisissez les
                        informations modifiables et visibles sur l'application
                        mobile.{' '}
                      </p>
                    </Grid.Column>
                    <Grid.Column>
                      <Header
                        icon
                        as="h3"
                        style={{
                          padding: '1em 0',
                          color: 'rgba(255,255,255,0.8)'
                        }}
                      >
                        <Icon name="download" /> Récupérez les données
                      </Header>
                      <p>
                        {' '}
                        L'API de Paraphe Online vous permet de récupérer les
                        informations modifiées et/ou ajoutées au document{' '}
                      </p>
                      <p>
                        {' '}
                        Le document signé peut également être téléchargé via
                        l'API ou envoyé par email.{' '}
                      </p>
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </div>
      </Container>
    );
  }
}

export default AboutSection;



// WEBPACK FOOTER //
// ./src/components/AboutSection.js